import React, { ReactNode } from "react";
import { mergeClass } from "../../utils/common";

export const Text14lh24 = ({
  children,
  vari,
}: {
  children: ReactNode;
  vari: "BLACK" | "BLUE";
}) => {
  return (
    <p
      className={mergeClass(
        "h-[24px] text-end text-sm font-normal leading-[24px]",
        vari === "BLACK" ? "text-[#000000]" : "",
        vari === "BLUE" ? "text-[#6790AC]" : "",
      )}
    >
      {children}
    </p>
  );
};
